import React, { useState, useEffect, useRef } from "react";
import RoomCarousel from "./RoomCarousel";

export default function LazyLoadCarousel({ images, onImageClick }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="min-h-[250px]">
      {isVisible ? (
        <RoomCarousel images={images} onImageClick={onImageClick} />
      ) : (
        <div className="flex justify-center items-center h-56 bg-gray-200 animate-pulse rounded-lg">
          <span className="text-gray-500">Loading...</span>
        </div>
      )}
    </div>
  );
}
